module.exports = __webpack_public_path__ + "static/media/1015105.ffd17b87.jpg";